import React, { Component } from 'react';
import { get } from 'lodash';
import styled from 'styled-components';

import IconCLoudOff from '@material-ui/icons/CloudOff';
import Loading from 'components/Loading/Loading';
import LoaderSmall from 'components/loaders/LoaderSmall';
import { defaultCell, tableConfigNew } from './config';
import CopiedSnackbar from './CopiedSnackbar/CopiedSnackbar';
import EventsTable from '../EventsTable';
import AlertScreen from '../AlertScreen';

const StyledEvents = styled.div`
  width: 100%;
  max-width: calc(100% - 360px);
  // margin: 0 15px 0;
  overflow-y: auto;
  position: relative;
`;

const InfiniteLoader = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  padding: 5px 0;
`;

class Events extends Component {
  constructor(props) {
    super(props);
    this.state = { openSnackbar: false };
    this.handleOpenSnackbar = this.handleOpenSnackbar.bind(this);
    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this);
  }

  componentDidMount() {
    this.props.initScrollEvent();
  }

  handleOpenSnackbar() {
    this.setState({ openSnackbar: true });
  }

  handleCloseSnackbar() {
    this.setState({ openSnackbar: false });
  }

  render() {
    const {
      eventsData,
      fetchingData,
      eventsSort,
      fetchingDataFailure,
      showProgressScroll,
      selectedEvent,
      sortTable,
    } = this.props;
    const { openSnackbar } = this.state;
    const noData = eventsData && !eventsData.length;
    const viewConfig = get(tableConfigNew, selectedEvent);
    if (fetchingData) return <Loading loadingLabel="Data on the way..." />;
    if (noData) return <AlertScreen icon={<IconCLoudOff />}>No data for this view</AlertScreen>;
    if (fetchingDataFailure) return <AlertScreen icon={<IconCLoudOff />} type="warning">Data was not loaded</AlertScreen>;

    return (
      <StyledEvents className="js-DetailsEvents__scroll">
        <EventsTable
          eventsData={eventsData}
          eventsSort={eventsSort}
          sortTable={sortTable}
          defaultCell={defaultCell}
          viewConfig={viewConfig}
          handleOpenSnackbar={this.handleOpenSnackbar}
        />

        {showProgressScroll && (
          <InfiniteLoader>
            <LoaderSmall />
          </InfiniteLoader>
        )}

        <CopiedSnackbar
          open={openSnackbar}
          handleClose={this.handleCloseSnackbar}
        />
      </StyledEvents>
    );
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/Events/Events.jsx